export default {"src":"/_next/static/media/cii.32516629.svg","height":108,"width":174};